module.exports = __webpack_public_path__ + "img/monterey-high-angle.44e13b8f.png";